/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const observer = new IntersectionObserver(entries => {
  let delay = 0;
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      setTimeout(function () {
      entry.target.classList.remove('blm-lazyload');
      entry.target.classList.add('blm-lazyloaded');
      }, delay);

      delay += 220;
      observer.unobserve(entry.target);
    }
  });
},
{
  threshold: [0.2]
});
  
const lazyloadItems = document.querySelectorAll('.blm-lazyload');
lazyloadItems.forEach(lazyloadItem => observer.observe(lazyloadItem));

// Prefilling questionnaire data from calculator selections
window.onload = () => {
  var retrievedObject = localStorage.getItem('selectedUserValues');
  var selectedUserValues = JSON.parse(retrievedObject);
  var ordersOptions = document.querySelector('select[name="field[36]"]').options;
  var membershipOptions = document.querySelector('select[name="field[38]"]').options;
  var shopifyOptions = document.querySelectorAll('._form_element._field43 fieldset input');

  
  //  ==== Need to update once form is updated ====

  // for (var i = 0, ordersOptionsLength = ordersOptions.length; i < ordersOptionsLength; i++) {
  //   var option = ordersOptions[i].value.replace(/\s+|,/g, '')
  //   console.log(option);
  //   if (option === selectedUserValues[0].orders) {
  //     document.querySelector('select[name="field[36]"]').selectedIndex = i;
  //   }
  // }

  for (var i = 0, membershipOptionsLength = membershipOptions.length; i < membershipOptionsLength; i++) {
    var option = membershipOptions[i].value.replace(/\s+|,/g, '')
    console.log(option);
    if (option === selectedUserValues[0].membership) {
      document.querySelector('select[name="field[38]"]').selectedIndex = i;
    }
  }

  for (var i = 0; i < shopifyOptions.length; i++) {
    var option = shopifyOptions[i].value;
    if (option.includes(selectedUserValues[0].shopify)) {
      shopifyOptions[i].checked = true;
    }
  }
}

// If cookie consent button is clicked, change padding on footer 
setTimeout(function() {
  document.querySelector('.hulk_cookie_bar .button_div').addEventListener('click', function() {
    document.querySelector('.Footer').style.paddingBottom = "64px";
  });
}, 2000);